<template>
  <step-container :number="stepNumber" title="¿Quién(es) hablará(n) en la grabación?">
    <div class="flex flex-col justify-start items-center flex-grow basis-1/2">
      <card-option
        v-model="option"
        :content="true"
        index="0"
        name="interviewee"
        :stepNumber="stepNumber"
      >
        <card-option-content
          title="Sólo el/la protagonista"
          description="Entrevistamos a quien recibe el regalo en base a preguntas sobre capítulos de su vida que enviaron sus cercanos, armando una biografía/documental con el/ella como protagonista"
          :imageSrc="singleUserIcon"
        >
          <template #title>
            <video-modal
              dialogTitle="Entrevista a protagonista - Memooria Tradicional"
              videoSource="https://s3.us-east-2.amazonaws.com/app.memoorias.com/public/Memooria+tradicional.mp4"
              triggerLabel="¿Qué significa?"
            />
          </template>
        </card-option-content>
      </card-option>
    </div>

    <div class="flex flex-col justify-start items-center basis-1/2 flex-grow">
      <card-option
        v-model="option"
        :content="false"
        index="1"
        name="interviewee"
        :stepNumber="stepNumber"
      >
        <card-option-content
          title="Otro(s)"
          description="Cercanos a quien recibe el regalo le dedicarán palabras y recordarán  historias en común durante una breve entrevista a cada un@"
          :imageSrc="multipleUserIcon"
        >
          <template #title>
            <video-modal
              dialogTitle="Entrevistas a cercanos del protagonista - Memooria Tributo"
              videoSource="https://s3.us-east-2.amazonaws.com/app.memoorias.com/public/Memooria+N-1.mp4"
              triggerLabel="¿Qué significa?"
            />
          </template>
        </card-option-content>
      </card-option>
    </div>
  </step-container>
</template>

<script setup>
import singleUserIcon from "@assets/images/quotation/single-user.svg";
import multipleUserIcon from "@assets/images/quotation/multiple-user.svg";
</script>

<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

import VideoModal from "../VideoModal.vue";
import CardOption from "../options/CardOption.vue";
import CardOptionContent from "../options/CardOptionContent.vue";

export default {
  mixins: [stepMixin, optionMixin],
  components: {
    CardOption,
    CardOptionContent,
  },
};
</script>
